import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row } from 'antd';
import { useHistory } from 'react-router-dom';
import GraficoPizza from 'components/GraficoPizza';
import CardSupervisor from 'components/CardPorcentagemRequerimento';
import { fetchBuscarGraficoSupervisor } from 'store/fetchActions/fetchFormulario';
import { fetchGetAtendenteByDocumento, fetchGetAtendentesLista } from 'store/fetchActions/fetchAtendente';
import { fetchStatusModalUsuarioPendente } from 'store/fetchActions/fetchApp';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';
import { homeContribuinte, rotaAtendente } from 'routes/paths';
import { ENUM_CONDICAO_STATUS, ENUM_MODAL } from 'utils/consts';
import { descricao, montarArrayExibir, montarGraficoPizza } from './HomeSupervisor';
import * as S from './styles';
import * as Style from 'components/Style';

export default function PrivatePage() {
  const history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector(state => state.sefaz.userProfile);
  const dadosGrafico = useSelector(state => state.formulario.dadosGrafico);
  const atendenteLogado = useSelector(state => state.atendente.atendenteLogado);

  React.useEffect(() => {
    if (user?.profile === ENUM_TIPO_PERFIL.SUPERVISOR) {
      dispatch(fetchGetAtendentesLista(1, 30, { condicaoId: ENUM_CONDICAO_STATUS.SOLICITADO.id })).then(
        atendentePendente => {
          if (atendentePendente?.totalRecords > 0) {
            dispatch(
              fetchStatusModalUsuarioPendente(true, ENUM_MODAL.LISTA_ATENDENTE_PENDENTE, {
                lista: atendentePendente?.list,
              })
            );
          }
        }
      );
    }
    // eslint-disable-next-line
  }, [dispatch, user]);

  React.useEffect(() => {
    if (user) {
      if (user?.profile === ENUM_TIPO_PERFIL.ATENDENTE) {
        history.push(rotaAtendente);
      }
      if (user?.profile === ENUM_TIPO_PERFIL.CONTRIBUINTE) {
        history.push(homeContribuinte);
      }

      dispatch(fetchGetAtendenteByDocumento(user?.cpf_cnpj, atendenteLogado)).then(() => {
        dispatch(fetchBuscarGraficoSupervisor());
      });
    }
    // eslint-disable-next-line
  }, [dispatch, history, user]);

  return (
    <S.Page>
      <Style.GlobalCard>
        <S.Titulo>FAS</S.Titulo>
        <S.Subtitulo>FORMULÁRIO DE ATENDIMENTO SEFAZ</S.Subtitulo>
        <S.Descricao>{descricao(user?.given_name, user?.profile)}</S.Descricao>

        <Row>
          {montarArrayExibir(dadosGrafico, user?.profile).map(item => {
            return (
              <CardSupervisor
                key={item.id}
                cor={item.cor}
                titulo={item.descricao}
                valor={item.valor}
                porcentagem={item?.porcentagem}
              />
            );
          })}
        </Row>
        <GraficoPizza
          dados={montarGraficoPizza(dadosGrafico, user?.profile)}
          height={'650px'}
          width={'850px'}
          margin={'50px auto auto auto'}
        />
      </Style.GlobalCard>
    </S.Page>
  );
}
